import { Group, Button, Text, Stack } from '../../../components/gab/GabComponents';

const SEVERITY_LEVELS = [
  { value: 1, label: '1', description: 'Minimal', color: 'green' },
  { value: 2, label: '2', description: 'Low', color: 'teal' },
  { value: 3, label: '3', description: 'Moderate', color: 'yellow' },
  { value: 4, label: '4', description: 'High', color: 'orange' },
  { value: 5, label: '5', description: 'Severe', color: 'red' },
];

interface Props {
  value: number | null;
  onChange: (val: number) => void;
}

export default function SeverityRating({ value, onChange }: Props) {
  return (
    <Stack gap="xs">
      <Text fw={500} size="sm">Severity Rating</Text>
      <Group gap={6} style={{ flexWrap: 'nowrap' }}>
        {SEVERITY_LEVELS.map(level => (
          <Button
            key={level.value}
            size="md"
            variant={value === level.value ? 'filled' : 'outline'}
            color={level.color}
            onClick={() => onChange(level.value)}
            style={{ flexDirection: 'column', height: 54, padding: '4px 2px', flex: 1, minWidth: 0 }}
          >
            <Text fw={700} size="lg" lh={1}>{level.label}</Text>
            <Text size="9px" lh={1} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '100%' }}>{level.description}</Text>
          </Button>
        ))}
      </Group>
    </Stack>
  );
}
